import { lazyOpenBizChatSidePane } from 'owa-bizchat-shared';
import { type LocalizedString } from 'owa-localize';
import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';

export type OpenChatPaneOptions = {
    params?: Partial<OpenBizChatSidePaneParams>;
    promptText: LocalizedString;
    targetWindow: Window;
};

/**
 * Opens the Copilot chat side pane with the specified prompt text and DAB source attribution.
 */
export const openChatPane = ({ params, promptText, targetWindow }: OpenChatPaneOptions): void => {
    lazyOpenBizChatSidePane.importAndExecute({
        ...params,
        isNewChat: true,
        promptText,
        targetWindow,
        source: 'CopilotDabRibbonSUA',
    });
};
